export const moduleConstant = {
  apiConstant: `/api/prodDept/scrapNoteReportRoute`,
  heading: 'SCRAP NOTE',
};
